@.landingsModuleHandler = ->
    $(document).ready(->
        bindLandingEvents()
        bindTrackEvents()
    )
    eventCategory = $('div[data-landing-name]').first().attr('data-landing-name')
    # custom callback function fired if sending event to GA ended with success
    landingHitCallback = -> return true
    bindLandingEvents = ->
        $(document).on('click', '.whitepaper-btn', (e) ->
            trackEvent(eventCategory, 'form open', 'whitepaper form', false)
            e.preventDefault()
            $('.modal-whitepaper').addClass('active')
        )
        $('form').on('submit', (e) ->
            modal = $(this).parents('div.modal-overlay')
            data_type = modal.attr('data-type')
            if (data_type == 'whitepaper')
                trackEvent(eventCategory, 'download', 'whitepaper form', true,)
            else if (data_type == 'customize')
                href = $(this).data('href')
                if href
                    window.location.href = href
            else
                trackEvent(eventCategory, 'submit', data_type + ' form', true,)
                e.stopPropagation()
                modal.find('.jsModalContentChange').hide()
                modal.find('.jsModalThxContent').show()
            thxBtn = modal.find('.jsModalThxButton')
            thxBtn.on('click', ->
                modal.removeClass('active')
            )
        )
        $(document).on('click', 'button[data-type]', (e) ->
            data_type = $(this).data('type')
            trackEvent(eventCategory, 'form open', data_type + ' form', false)
            if (data_type == 'chat')
                trackEvent(eventCategory, 'form open', 'chat form', false)
                $zopim.livechat.window.show()
            else if (data_type == 'customize') or (data_type == 'url')
                href = $(this).data('href')
                if href
                    window.location.href = href
            else
                modalSelector = '.modal-' + data_type
                $(modalSelector).addClass('active')
                $(modalSelector).attr('data-type', data_type)
        )

        landingDesc = $('.jsLandingDesc')
        landingDesc.each(() ->
            paragraphs = $(this).children('p')
            paragraphs.each(() ->
                $(this).find('img').parents('p').css('column-count', 1)
            )
        )

        if( window.innerWidth < 992)
            $('.modal-lp-content__form').each(() ->
                moduleTitle = $(this).find('.jsModalFormTitle').height()
                moduleDesc = $(this).find('.jsModalFormDesc').height()
                moduleFormContent = $(this).find('.jsModalFormContent').height()
                moduleRodo = $(this).find('.jsModalFormRodo')

                moduleHeight = $(this).height() - moduleTitle - moduleDesc - 70
                if( moduleHeight > moduleFormContent )
                    moduleMargin = $(this).height() - moduleTitle - moduleDesc - moduleFormContent - 150
                    moduleRodo.css('margin-top', ( moduleMargin + 'px'))
            )

        landingDesc = $('.jsLandingDesc')
        landingDesc.each(() ->
            paragraphs = $(this).children('p')
            paragraphs.each(() ->
                $(this).find('img').parents('p').css('column-count', 1)
            )
        )

    bindTrackEvents = -> (
        ###
        GA event data generated as follows:
        1. category - will be automatically set to title of landing page which is specified in admin panel
        2. event type - possible value: click, form open, form close, download
        3. label: string from data-track-label attribute or id or href in all else fails
            * data-track-label is generated in following manner: <[project|product|article]: title>
            * label for events related to whitepaper modal are always set to 'whitepaper form'
        ###
        $(document).on('click', 'a', (e) ->
            label = $(this).attr('data-track-label') || $(this).attr('id') || $(this).attr('href')
            action = 'click'
            # we do not track click on link with anchor equal to '#' as it should be tracked by custom events rather than
            # normal click action
            if label != '#'
                trackEvent(eventCategory, action, label, true)
        )
        $('.modal-button').on('click', (e) ->
            action_type = $(this).parents('form').find('input[name="submission_type"]').data('action')
            event_target = action_type + ' form'
            trackEvent(eventCategory, 'form submit', event_target)
        )
    )
